import { isExternal, isEmpty, observeElements } from '../util/helpers'
//import debounce from 'lodash/debounce'

export default {
  init() {
    // JavaScript to be fired on all pages
    const body = document.querySelector('body')
    const navToggles = [].slice.call(document.querySelectorAll('.js-toggle-nav'))
    const anchors = [].slice.call(document.querySelectorAll('a'))
    const pTags = [].slice.call(document.querySelectorAll('p'))
    const heroBackground = document.querySelector('.js-hero')
    const backgrounds = [].slice.call(document.querySelectorAll('.js-background'))
    const startToggles = [].slice.call(document.querySelectorAll('.js-start'))
    const jsPopup = document.querySelector('.js-popup')

    // Add a loading state to the site
    window.addEventListener('load', () => {
      document.body.classList.add('loaded')
    })

    // Handle toggling mobile menu
    if (navToggles) {
      navToggles.forEach(navToggle => {
        navToggle.addEventListener('click', () => {
          body.classList.toggle('nav-is-open')
        })
      })
    }

    // Handle start form toggling
    if (startToggles) {
      startToggles.forEach(startToggle => {
        startToggle.addEventListener('click', () => {
          body.classList.toggle('form-is-open')
        })
      })
    }

    // Handle external urls
    if (document.body.classList.contains('.single-portfolio')) {
      anchors.forEach(anchor => {
        if (isExternal(anchor)) {
          // Define attributes to set
          const attributes = {
            target: '__blank',
            rel: 'noopener',
          }

          // Set attributes
          Object.keys(attributes).forEach(attribute => {
            anchor.setAttribute(attribute, attributes[attribute])
          })
        }
      })
    }

    // Handle empty p tags
    pTags.forEach(isEmpty)

    // Handle hero background
    if (heroBackground) {
      const mobileHero = heroBackground.dataset.mobile
      const desktopHero = heroBackground.dataset.desktop

      if (!mobileHero && !desktopHero) return

      heroBackground.classList.add('has-background')

      if (window.matchMedia('(min-width: 1024px)').matches) {
        heroBackground.style.backgroundImage = `url(${desktopHero})`
      } else {
        heroBackground.style.backgroundImage = `url(${mobileHero})`
      }
    }

    // Handle post backgrounds
    // Either use the Intersection Observer API or a default method
    if (backgrounds) {
      if (('IntersectionObserver' in window)) {
        let observer = new IntersectionObserver(observeElements);

        backgrounds.forEach(background => {
          observer.observe(background)
        })
      } else {
        backgrounds.forEach(background => {
          background.classList.add('has-background')

          const mobileBG = background.dataset.mobile
          const desktopBG = background.dataset.desktop

          if (!mobileBG && !desktopBG) return

          if (window.matchMedia('(min-width: 1024px)').matches) {
            background.style.backgroundImage = `url(${desktopBG})`
          } else {
            background.style.backgroundImage = `url(${mobileBG})`
          }

          background.classList.add('has-loaded')
        })
      }
    }

    // Handle posts
    if (window.matchMedia('(max-width: 767px)').matches) {
      if ($('.js-posts').length) {
        $('.js-posts').slick({
          accessibility: true,
          adaptiveHeight: false,
          autoplay: true,
          autoplaySpeed: 15000,
          arrows: false,
          dots: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
      }
    }

    // Handle testimonials
    if ($('.js-testimonials').length) {
      $('.js-testimonials').slick({
        accessibility: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 15000,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1000,
        slidesToShow: document.body.classList.contains('page-template-template-good-sam') ? 2 : 3,
        slidesToScroll: document.body.classList.contains('page-template-template-good-sam') ? 2 : 3,
        responsive: [
          {
            breakpoint: 1335,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 666,
            settings: {
              adaptiveHeight: true,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      }).on('setPosition', function () {
        if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).find('.slick-slide').height('auto');
          var slickTrack = $(this).find('.slick-track');
          var slickTrackHeight = $(slickTrack).height();
          $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
        }
      });
    }

    if ($('.js-gallery').length) {
      $('.js-gallery').slick({
        accessibility: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 15000,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 666,
            settings: {
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    if ($('[data-fancybox="portfolio"]').length) {
      $('[data-fancybox="portfolio"]').fancybox({
        infobar: false,
      })
    }

    // Handle js popup
    if (jsPopup) {
      setTimeout(() => {
        $.fancybox.open({
          autoFocus: false,
          src: jsPopup,
          type: 'inline',
        })
      }, 5000)
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    if (!document.body.classList.contains('page-template-template-good-sam') && !document.body.classList.contains('page-template-template-good-sam-rep') && !document.body.classList.contains('page-template-template-good-sam-questionnaire') && !document.body.classList.contains('page-template-template-landing-knockoff')) {
      let initialPos = 0

      window.addEventListener('scroll', function () {
        if (this.scrollY !== 0 && this.scrollY > 0) {
          let currentTop = document.body.getBoundingClientRect().top

          if (currentTop > initialPos) {
            document.body.classList.add('scrolling-up')
            document.body.classList.remove('scrolling-down')
          } else {
            document.body.classList.remove('scrolling-up')
            document.body.classList.add('scrolling-down')
          }

          initialPos = currentTop
        } else {
          document.body.classList.remove('scrolling-down')
          document.body.classList.remove('scrolling-up')
        }
      })
    }

    if ($('.video').length) {
      // Find all YouTube videos
      var $allVideos = $('iframe[src^="https://www.youtube.com"]'),

        // The element that is fluid width
        $fluidEl = $('.video');

      // Figure out and save aspect ratio for each video
      $allVideos.each(function () {

        $(this)
          .data('aspectRatio', this.height / this.width)

          // and remove the hard coded width/height
          .removeAttr('height')
          .removeAttr('width');

      });

      // When the window is resized
      $(window).resize(function () {

        var newWidth = $fluidEl.width();

        // Resize all videos according to their own aspect ratio
        $allVideos.each(function () {

          var $el = $(this);
          $el
            .width(newWidth)
            .height(newWidth * $el.data('aspectRatio'));

        });

        // Kick off one resize to fix all videos on page load
      }).resize();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js